import { useTheme } from "@mui/material";
import type { FC } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { AdvisorAssistantPageBody } from "web_myplann/Advisor/Components/AdvisorAssistantPageBody";
import { AdvisorDeleteAction } from "web_myplann/Advisor/Components/AdvisorDeleteAction";
import { useConnectedAdvisor } from "web_myplann/Advisor/Hooks/useConnectedAdvisor";
import { useAdvisorDetailQuery } from "web_myplann/Api/Advisor/useAdvisorDetailQuery";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { getRoute } from "web_myplann/Infrastructure/Utils/UrlUtils";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import NavigationHeader from "web_myplann/Shared/Header/NavigationHeader";
import { useNavigateBackOrDefault } from "web_myplann/Shared/Hooks/useNavigateBackOrDefault";
import { getTypedParam } from "web_myplann/Shared/Utils/getTypedParam";

export const AdvisorAssistantPage: FC = () => {
	const theme = useTheme();
	const { t } = useResource();
	const routeParams = useParams<{ uid: string }>();
	const [searchParams] = useSearchParams();
	const uid = getTypedParam(routeParams, "uid", String);
	const { data: detail, isLoading } = useAdvisorDetailQuery(uid);
	const assistant = useConnectedAdvisor(uid);
	const { data: advisor } = useAdvisorDetailQuery(
		getTypedParam(searchParams, "advisorUid", String),
	);
	const navigateBack = useNavigateBackOrDefault(getRoute(Routing.Advisor));

	return (
		<MyPlannLayout
			disableContentPadding
			bgColor={theme.palette.background.paper}
			topBar={
				<NavigationHeader
					title={t(Resources.Advisor.assistant)}
					titleVariant="h3"
					bgColor={theme.palette.background.appBar}
					defaultRoute={Routing.Advisor}
					backIconColor={theme.palette.grey[900]}
					backIconSize={theme.iconSize.md}
					endComponent={
						<AdvisorDeleteAction advisor={assistant} onDeleted={navigateBack} />
					}
				/>
			}
		>
			<AdvisorAssistantPageBody
				isLoading={isLoading}
				detail={detail}
				advisorName={advisor?.name ?? undefined}
				onBackToAdvisor={navigateBack}
			/>
		</MyPlannLayout>
	);
};
